import axios from 'axios';

const updateLocationsAndUnits = function (target) {
  const row = $(target).parents('tr');
  const lotSelect = row.find('.issue-product-lot-select');
  const locationSelect = row.find('.issue-product-location-select');
  const unitSelect = row.find('.issue-product-unit-select');

  axios
    .get('/locations_by_product_lot', {
      params: { product_lot_id: lotSelect.val() },
    })
    .then(response => {
      locationSelect.empty();
      $.each(response.data, function (_, location) {
        locationSelect.append(
          $('<option>', {
            text: location.warehouse_path,
            value: location.id,
          })
        );
      });
      locationSelect.trigger('change');
    })
    .catch(error => {
      console.log(error.response.data);
    });

  axios
    .get('/product_lot_group_measurement_units', {
      params: { product_lot_id: lotSelect.val() },
    })
    .then(response => {
      unitSelect.empty();
      $.each(response.data, function (_, unit) {
        unitSelect.append(
          $('<option>', {
            text: unit.name,
            value: unit.id,
          })
        );
      });
      unitSelect.trigger('change');
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

const applyIssuesSelect2 = function () {
  $('.issue-product-lot-select').select2({
    placeholder: 'Buscar un lote (código o nombre de producto)',
    minimumInputLength: 3,
  });
  $('.issue-product-location-select').select2({
    placeholder: 'Seleccione una ubicación',
  });
  $('.issue-product-unit-select').select2({
    placeholder: 'Seleccione una unidad de medida',
  });
};

document.addEventListener('turbolinks:load', function () {
  applyIssuesSelect2();
  $('.issue-product-lot-select').on('change', function (e) {
    updateLocationsAndUnits($(e.currentTarget));
  });
  $('#issue-products-fields').on('cocoon:after-insert', function () {
    applyIssuesSelect2();
    $('.issue-product-lot-select').on('change', function (e) {
      updateLocationsAndUnits($(e.currentTarget));
    });
  });
});
